import React, { useState } from 'react';

// Utils
import { useQuery } from 'react-query';
import { useAppContext } from '../../../../store/AppContext';
import adminTypes from '../../../../constants/adminTypes';

// Services
import useRolesService from '../../../../services/rolesService';

// Components
import RolesTable from '../../../tables/RolesTable/RolesTable';
import RoleCreation from '../../../tables/RolesTable/RoleCreation/RoleCreation';
import PermissionsGate from '../../../../utils/gate/permissionsGate';
import SCOPE from '../../../../utils/gate/scope';

function Roles() {
  const [{ adminType }] = useAppContext();

  const [roles, setRoles] = useState(null);
  const [permissions, setPermissions] = useState([]);

  const { getEstablishmentRoles } = useRolesService();
  const { getPlatformRoles, getAllPermissions } = useRolesService();

  const { isFetching: isFetchingEstRoles } = useQuery(['getEstablishmentRoles'], () => getEstablishmentRoles(), {
    enabled: adminType === adminTypes.establishment,
    onSuccess: (res) => setRoles(res?.data?.establishmentRoles || []),
  });

  const { isFetching: isFetchingPlatformRoles } = useQuery(['getPlatformRoles'], () => getPlatformRoles(), {
    enabled: adminType === adminTypes.platform,
    onSuccess: (res) => setRoles(res?.data?.platformRoles || []),
  });

  const { isFetching: isFetchingPermissions } = useQuery(['getAllPermissions'], () => getAllPermissions(), {
    onSuccess: (res) => setPermissions(
      res?.data?.platformRolePermissions
      || res?.data?.establishmentRolePermissions
      || [],
    ),
  });

  const isTableFetching = () => (isFetchingEstRoles || isFetchingPlatformRoles || isFetchingPermissions);

  return (
    <>
      <RolesTable
        roles={roles}
        setRoles={setRoles}
        isFetching={isTableFetching()}
        permissions={permissions}
      />

      {!isTableFetching() ? (
        <PermissionsGate scopes={[SCOPE.create_pla_role, SCOPE.create_ownEst_role]}>
          <div className="d-flex a-center j-end sticky-actions mobile-a-stretch">
            <RoleCreation
              permissions={permissions}
              setRoles={setRoles}
            />
          </div>
        </PermissionsGate>
      ) : null}
    </>
  );
}

Roles.propTypes = {};

export default Roles;
